export interface IReview {
    text: string;
    lang: string;
    source:
        | "Apple User"
        | "Android User"
        | "HackerNews"
        | "Reddit"
        | "Community Member"
        | "Cryptographer";
    /* Present for HackerNews, Reddit and Community reviews */
    link?: string;
    who?: string;
}

const reviews: IReview[] = [
    {
        text: "Ente is really cool. End-to-end encrypted photo backup/sync (unlike Google Photos), truly multiplatform (unlike iCloud Photos), and fully open source (unlike both!)\n\nFull disclosure: @symbolicsoft was involved in a cryptographic audit of Ente.",
        lang: "en",
        source: "Cryptographer",
        who: "Nadim Kobeissi",
    },
    {
        text: "I've been using Ente Photos for around 2 years and couldn't be happier with the product. It puts privacy first but doesn't sacrifice features, the on device AI works great. It even recognizes images from when I was younger. Definitely sticking with this product, the developers are very helpful and are always open for listening to feedback. Great community overall!",
        lang: "en",
        source: "Android User",
        who: "Brogio",
    },
    {
        text: "Looked far and wide for a cloud photos app like this: zero-knowledge encryption, displays thumbnails quickly, handles “live” iPhone photos without separating them, respects HEIC format, retains original quality and EXIF metadata, allows for cross-platform syncing and family sharing. Happy to support an app that emphasizes privacy without sacrificing functionality.",
        lang: "en",
        source: "Apple User",
        who: "fishfighter22",
    },
    {
        text: "Been using Ente for over a year now and this continues to be a suitable Google Photos replacement for me and my family! It's still in need of some key features (automated compressed video previews for quick viewing and being the biggest one right now) , but the core is solid and it seems like the dev team is passionate about implementing features important to their users. Really happy with this app!",
        lang: "en",
        source: "Android User",
        who: "Sam Winger",
    },
    {
        text: "Customer service from Ente is nothing short of amazing. The team replies promptly and is always courteous. I had a small issue with the app and they pushed an update in under 10 hours. The issue was completely resolved. I’ve had subscriptions with all the major E2EE storage apps and they don’t come close in any aspect.",
        lang: "en",
        source: "Apple User",
        who: "Cream of melon",
    },
    {
        text: "I am really positively surprised. The app works flawlessly and makes managing pictures and videos across multiple platforms (mobile, tablet, laptop, and web) very easy. In addition, all data is end to end encrypted, which was crucial for me to start using the app. The prices are really fair and there is a great team behind Ente that is incredibly open to feature suggestions. It's a pity that I didn't come across Ente earlier. In summary, Ente is a great alternative to the big cloud providers and is not lagging behind them. At the same time, Ente makes it possible to store data securely and privately, without the hassle that normally comes with it.",
        lang: "en",
        source: "Apple User",
        who: "luk0411",
    },
    {
        text: "Excellent privacy friendly alternative to Google photos. Developer fixed a small bug witin 2 days!",
        lang: "en",
        source: "Android User",
        who: "Michiel van Drunen",
    },
    {
        text: "Best privacy-friendly replacement for Google photos I've come across so far. Beautiful interface, great map function and fair prices. Recommended!",
        lang: "en",
        source: "Android User",
        who: "Henning Lagemann",
    },
    {
        text: "Another superb app by team ente. It is a great alternative to the other photo storage apps currently available. It is a great looking app and it is easy on the eye. The functionality is top notch. It is E2EE for peace of mind. The fees are extremely competitive too. It was a little sluggish to use, but the latest update fixed that problem. Thank you! Highly recommended.",
        lang: "en",
        source: "Android User",
        who: "Jacques Vivier",
    },
    {
        text: "Great app for backing up photos. I love how easy it is to use and that it's more secure and private than google. It makes it really easy to manage photos and free up space on your phone knowing your photos are saved on its server.",
        lang: "en",
        source: "Android User",
        who: "Peter",
    },
    {
        text: "Ente is the perfect app for anyone looking to backup and organize their photos and videos securely. With end-to-end encryption and multiple storage locations, my memories are safe and accessible from any device. I also love the option to share albums with loved ones and the ability to free up space by removing safely backed-up files. The pricing is affordable and the human support is top-notch. Highly recommend!",
        lang: "en",
        source: "Android User",
        who: "V Keerthi Vikram",
    },
    {
        text: "Privacy-friendly alternative to Google Photos. Family plan at no extra cost! Good price, great app.",
        lang: "en",
        source: "Android User",
        who: "Daniel & Rie",
    },
    {
        text: "This is the best alternative to Google Photos currently available. The UI is really well designed and they are continually implementing new features with frequent updates",
        lang: "en",
        source: "Android User",
        who: "Peter Montague",
    },
    {
        text: "Ente has been a great way to share photos with a partner! Bonus it works on all platforms too!",
        lang: "en",
        source: "Android User",
        who: "Paul Hovey",
    },
    {
        text: "The best e2ee storage for photos and videos. A new star on the privacy Haven.",
        lang: "en",
        source: "Android User",
        who: "Patriii",
    },
    {
        text: "Hello developers, keep up the excellent work and never stop improving this app whatsoever It's become my primary photo gallery for my entire life The way you guys respect people's privacy is so appreciated 5 STAR with love ❤️❤️",
        lang: "en",
        source: "Apple User",
        who: "Ziyad Alahmadi",
    },
    {
        text: "This is just fantastic. There are a few missing features and rough edges but the developers are very active and responsive, so they will get sorted soon. In general, it's a well designed and reliable app that solved the problem of photo backup for someone who doesn't want to make compromises on privacy. So glad it exists",
        lang: "en",
        source: "Android User",
        who: "Leonardo Mazzone",
    },
    {
        text: "After trying 3 other encrypted photo storage options, I found ente far easier to use, photos are in the correct order, and the app itself is a thing of beauty! In my experience, ente is the most complete and offers the best experience overall. Encryption never looked so good!",
        lang: "en",
        source: "Android User",
        who: "David Keller",
    },
    {
        text: "Probably the best Google Photo replacement, with privacy in mind! Keep up the good work.",
        lang: "en",
        source: "Android User",
        who: "Robert Hedlund",
    },
    {
        text: "this is the best thing since sliced bread. On top of a very good app and a well thought out architecture you get a very friendly and super responsive team taking care of problems and feature requests. I wish I had known about this earlier.",
        lang: "en",
        source: "Apple User",
        who: "midshipmanorg",
    },
    {
        text: "One of the best google Photos alternative, It even has Family Plans 🤩. It also encrypts the metadata, while allowing to search through the metadata to find your photos.",
        lang: "en",
        source: "Community Member",
        link: "https://alternativeto.net/software/ente/about/#post-105436",
        who: "Vicky",
    },
    {
        text: "It works wonders. The developers are very quick to fix bugs when present and available in support. Photos are saved in maximum quality and synchronization is fast. The cost is really low (€10/year or €1/month for 10GB), and unlike Google Photo (free, meaning it makes money by selling our data), it is completely open-source, uses E2E encryption (while Google can easily see all the photos), and has a clear and clean privacy policy.",
        lang: "en",
        source: "Android User",
        who: "Pi",
    },
    {
        text: "Waiting & looking for this app for a long time. Thanks.",
        lang: "en",
        source: "Android User",
        who: "Kiarash Kay",
    },
    {
        text: "Best alternative to Google Photos",
        lang: "en",
        source: "Android User",
        who: "Quique Llaudet",
    },
    {
        text: "One of the best encrypted alternative to Google Photos.",
        lang: "en",
        source: "Android User",
        who: "Andrea Guani",
    },
    {
        text: "This is the Google Photos alternative I've been looking for.",
        lang: "en",
        source: "Android User",
        who: "Green",
    },
    {
        text: "Excellent, privacy oriented photo storage service.",
        lang: "en",
        source: "Android User",
        who: "Marcus “midshipman” Wille",
    },
    {
        text: "Love the product and the company. Future of internet",
        lang: "en",
        source: "Android User",
        who: "Sairee Chahal",
    },
    {
        text: "The best privacy alternative to Google Photos",
        lang: "en",
        source: "Community Member",
        link: "https://alternativeto.net/software/ente/about/#post-124728",
        who: "m00t316",
    },
    {
        text: "Very pretty, it surprised me",
        lang: "en",
        source: "Android User",
        who: "Pablo J",
    },
    {
        text: "Brilliant alternative to Google Photos, and it's encryption is top notch. Larger storage size options are really well priced too.. So glad I found this service. On a side note, one thing I'd love to see is a built in Exif cleaner option (something like Scrambled Exif). Thank you for this wonderful app, you have a very loyal customer here.",
        lang: "en",
        source: "Android User",
        who: "Ryan Simmons",
    },
    {
        text: "Open-source, actively maintaind, relatively cheap, E2E encrypted. Viable alternative to google photos, icloud photos and the like.",
        lang: "en",
        source: "Community Member",
        link: "https://alternativeto.net/software/ente/about/#post-115465",
        who: "aloofloofah",
    },
    {
        text: "Hellooo there! I am in awe!! You guys have done something that I've long wished for! Thank you so much for those cheap plans.",
        lang: "en",
        source: "Android User",
        who: "Mrinmay Dev Sarma",
    },
    {
        text: "Smooth experience with end to end encryption, can't find any better alternative to google photos than ente",
        lang: "en",
        source: "Android User",
        who: "Puneet Goyal",
    },
    {
        text: "can i rate more than 5 stars please?",
        lang: "en",
        source: "Android User",
        who: "大牛",
    },
    {
        text: "Best encrypted alternative to Google Photos.",
        lang: "en",
        source: "Community Member",
        link: "https://alternativeto.net/software/ente/about/#post-109682",
        who: "skariko",
    },
    {
        text: "Great app, have been using for a couple of months now. The 2fa and opensource code makes it more secure than using google photos.",
        lang: "en",
        source: "Android User",
        who: "Gautham Santhosh",
    },
    {
        text: "This is amazing. I can sense a feeling of 'why' begin this app and I believe that's much powerful to drive this forward.",
        lang: "en",
        source: "Android User",
        who: "Aravind Venugopal",
    },
    {
        text: "Fast response from the devs fixed an issue. Great job!",
        lang: "en",
        source: "Android User",
        who: "Peter Engholm",
    },
    {
        text: "Absolutely beautiful and well working app, everything I need from a photo app, not from google and OSS! love this, keep up the great work, team!",
        lang: "en",
        source: "Android User",
        who: "kataklasm",
    },
    {
        text: "The best Google Photos alternative that I could find that actually respects your privacy. Absolutely love their product. While there are other privacy focused GP alternatives out there, Ente actually tries (and increasingly succeeds) to make something that is just as user friendly and feature packed.",
        lang: "en",
        source: "Community Member",
        link: "https://alternativeto.net/software/ente/about/#post-105728",
        who: "Laurens",
    },
    {
        text: "Have been on the lookout for a privacy friendly photo sync and backup solution and ente delivers. Now I feel my photos are truly safe.",
        lang: "en",
        source: "Android User",
        who: "Chaitanya Pramod",
    },
    {
        text: "This is probably the only, and best cloud photos option out there. Secure, private, open source, reliable, and beautiful UI. Obviously it's not perfect, it has SOME issues, but overall it's worth it!",
        lang: "en",
        source: "Apple User",
        who: "Sowers25",
    },
    {
        text: "Such a great project :) It looks and feels so intuitive out of the box, wonderful!",
        lang: "en",
        source: "Reddit",
        link: "https://www.reddit.com/r/enteio/comments/njg42s/hello_world/gze6h8r/",
        who: "u/bendavidi",
    },
    {
        text: "Take my money!!!",
        lang: "en",
        source: "HackerNews",
        who: "istingray",
        link: "https://news.ycombinator.com/item?id=28351288",
    },
    {
        text: "Thank God, something awesome like this finally exists. Thank youuuu to the devs of ente!",
        lang: "en",
        source: "Reddit",
        link: "https://www.reddit.com/r/degoogle/comments/njatok/comment/gz9nte9/",
        who: "u/coolbeb",
    },
    {
        text: "Ente is now my favorite :)",
        lang: "en",
        source: "Reddit",
        link: "https://www.reddit.com/r/enteio/comments/njg42s/comment/h5i641s/",
        who: "u/bendavidi",
    },
    {
        text: "Totally Awesome, great work and thanks!!",
        lang: "en",
        source: "Reddit",
        link: "https://www.reddit.com/r/degoogle/comments/njatok/comment/gz8y5gm/",
        who: "u/C4nn4Cat",
    },
    {
        text: "I really love your product",
        lang: "en",
        source: "HackerNews",
        who: "Rume",
        link: "https://news.ycombinator.com/item?id=28350311",
    },
    {
        text: "I like ente, I have been using it instead of google photos for almost a year and I have never regret it. A few euros yearly for a privacy-respecting alternative that does what it is supposed to do smoothly and simply is a big yes from me.",
        lang: "en",
        source: "Community Member",
        link: "https://alternativeto.net/software/ente/about/#post-105434",
        who: "Pietro Smusi",
    },
    {
        text: "they don't market enough as they probably should but it's a great cross-platform google photos alternative. the devs are very active too.",
        lang: "en",
        source: "Community Member",
        link: "https://alternativeto.net/software/ente/about/#post-104064",
        who: "p0xxy",
    },
    {
        text: "Would like to recommend ente to anyone trying to degoogle...automatic end-to-end encrypted backups of your photos and  videos, in their original quality.",
        lang: "en",
        source: "Community Member",
        link: "https://fosstodon.org/@naturallytony/108214697588297831",
        who: "Tony",
    },
    {
        text: "Siento que mis fotos están seguras en Ente. La privacidad es importante para mi. La app es muy intuitiva y fácil de usar. La recomiendo al 100%.",
        lang: "es",
        source: "Apple User",
        who: "RavalMatic",
    },
    {
        text: "Perfecta, sincroniza con el móvil rápido y claro, tiene un plan gratuito de 10gb y varios a partir de 50gb de pago.",
        lang: "es",
        source: "Android User",
        who: "J.C N.N",
    },
    {
        text: "Llevo mucho tiempo buscando una app que sustituya a Googl fotos la cual recopila una cantidad inmensa de datos, esta app es perfecta es bonita, es fluida es privada, de código abierto, con cifrado de extremo a extremo, de conocimiento cero solo tú tienes acceso a tus fotos, no te rastrea no recopila tus datos, simplemente perfecta, y aparte tiene una interfaz muy lograda y fluida se suben rápido las fotos y videos, se abren rápido y sin perder calidad, tiene reconocimiento de cara igual que la de Google la recomiendo 100% no suelo escribir reseñas pero esta app se lo merece.",
        lang: "es",
        source: "Apple User",
        who: "Annbvzl",
    },
    {
        text: "Perfecto para guardar tus fotos y documentos más privados con un cifrado excelente y el uso de su nube descentralizada...ah! Y su otro programa de autentificator también es de lo mejor..",
        lang: "es",
        source: "Android User",
        who: "vitorhino",
    },
    {
        text: "excelente aplicación muy fácil de utilizar y más simple q google fotos la recomiendo",
        lang: "es",
        source: "Android User",
        who: "Demon King",
    },
    {
        text: "Con ente tus fotos son tuyas. Nadie puede usarlas salvo tu. Y todo sin sacrificar la parte divertida de las apps de fotos.",
        lang: "es",
        source: "Android User",
        who: "Fernando Andina",
    },
    {
        text: "Super genial aplicación, es super segura, la mejor alternativa a google photos que existe y está en idioma español.",
        lang: "es",
        source: "Android User",
        who: "Hessel Miranda",
    },
    {
        text: "Excelente aplicación de código libre muy estable subida y descarga de archivos rápidamente se agradece el espacio gratis",
        lang: "es",
        source: "Android User",
        who: "Marcos Rodriguez Montoya",
    },
    {
        text: "Interface ist sehr gewöhnungsbedürftig. Alles funktioniert aber zuverlässig. Preis ist sehr fair. Alles synchronisiert gut. Die Apps laufen auf allen Plattformen. Fotos und Videos sind alle Ende-zu-Ende verschlüsselt. Die App selber ist auch frei von Werbung und Trackern. Aktuell (Januar 2023) die beste private Alternative zu iCloud.",
        lang: "de",
        source: "Apple User",
        who: "Dariush K",
    },
    {
        text: "Die Entwickler haben erkannt, dass Ende zu Ende Verschlüsselung, auch wenn wichtig, nur bei einer begrenzten Nutzergruppe ein Verkaufsargument ist. Hier wird alles richtig gemacht und eine echte Alternative zu Google Photos geliefert: Übersichtlich, Gruppierung nach Standort und Personen, ein kompetitiver Preis und natürlich alles mit E2E Verschlüsselung. Die Entwickler sind bei Bugs auch sehr hilfsbereit und kümmern sich um eine schnelle Lösung.",
        lang: "de",
        source: "Android User",
        who: "Pascal Kreutz",
    },
    {
        text: "Gute Alternative zu Google Fotos mit Fokus auf Privatsphäre um seine Bilder auf verschiedenen Systemen verfügbar zu haben.",
        lang: "de",
        source: "Apple User",
        who: "Hr Maus",
    },
    {
        text: "Toll umgesetzt, synchronisiert meine Fotos und Alben, AI ist nur Lokal, alles verschlüsselt und wenn ich nicht in die Cloud will (2.5€/Monat für 50GB), kann ich es auch zuhause auf einem PC hosten. Auch das private Teilen mit Leuten die kein Ente haben funktioniert super.",
        lang: "de",
        source: "Apple User",
        who: "AnasKoug",
    },
    {
        text: "Die App bietet fast alles, was man von einer Privatsphäre respektierenden App erwartet. On device encryption, geteilte Alben such an externe, einstellen der Zugriffsberechtigungen, uvm. Das beste ist jedoch, das die App sehr aktiv weiterentwickelt wird und schon viele Funktionen, die man ggf erwarten würde, wie zb alle Bilder eines Albums auszuwählen, schon implementiert wurden. Auf jeden Fall sollte man dieses tolle Team unterstützen!",
        lang: "de",
        source: "Android User",
        who: "Cedric Houdard",
    },
    {
        text: "Endlich eine App zur Fotoverwaltung, bei der meine Fotos und Videos sicher Ende-zu-Ende-verschlüsselt übertragen werden. Dazu einige Komfortfunktionen, die andere nicht haben, etwa ablaufende Links zu geteilten Alben. Die Qualität der Software, auch im Web und auf dem Desktop, sowie das Engagement der Entwickler haben mich überzeugt, von Google Fotos zu ente zu wechseln.",
        lang: "de",
        source: "Android User",
        who: "Stephan Windmüller",
    },
    {
        text: "Echt gut und wird immer noch besser! Chapeau!",
        lang: "de",
        source: "Android User",
        who: "Timo Lang",
    },
    {
        text: "Die perfekte App, um seine Fotos in der Cloud zu speichern. Durch die Verschlüsselung sind die privaten Fotos geschützt. Die App ist dadurch nicht langsamer. Auch die Teilen-Funktion ist super, um Fotos an Familie und Freunde zu schicken. Sie können dann auch selbst Fotos hochladen, was super praktisch ist.",
        lang: "de",
        source: "Android User",
        who: "Konrad",
    },
    {
        text: "J'ai fait une migration à partir de Google afin d'avoir le contrôle sur mes photos et avoir la possibilité de les sauvegarder facilement sans altérations. L'outil de recherche de photos est très bon dans plusieurs langues. La partage fonctionne assez bien aussi. Les fonctions d'édition de photos est plutôt limité, mais il est facile de le faire avec d'autres applications. La sécurité est l'un des points intéressants. J'ai fait une migration de près de 50000 photos.",
        lang: "fr",
        source: "Android User",
        who: "Éric Béliveau",
    },
    {
        text: "Interface agréable, l'auto-upload des photos marche parfaitement, on peut oublier Ente quelques semaines tout en ayant confiance dans la sauvegarde sécurisée de ses photos. Partage des photos plus simple que sur Google Photos, les memories sont efficaces, dossier caché, sélection des dossiers uploadés, création de dossiers automatiques selon le dossier d'origine... Le support est extrêmement réactif et compréhensif !",
        lang: "fr",
        source: "Android User",
        who: "Lulu",
    },
    {
        text: "Le meilleur appli pour les photos. Il protège ta vie privée sans enlever les fonctionnalités que t'expectes.",
        lang: "fr",
        source: "Android User",
        who: "James",
    },
    {
        text: "Enfin une app de cloud photos qui respecte la confidentialité de ses utilisateurs. Les aspects vie privée et sécurité sont respectés et c'est exactement ce qu'il manquait dans le monde des technologies actuelles.",
        lang: "fr",
        source: "Android User",
        who: "Wanigator",
    },
    {
        text: "Très bien ! Je ne regrette pas mon achat",
        lang: "fr",
        source: "Android User",
        who: "Michèle Perroud",
    },
    {
        text: "meilleure alternative à Google Photos",
        lang: "fr",
        source: "Android User",
        who: "Benoit Ravel",
    },
    {
        text: "Excellent stockage de photos crypté",
        lang: "fr",
        source: "Android User",
        who: "Sylvain Boulay",
    },
    {
        text: "Privacy-vriendelijk alternatief voor Google Photos. Family-plan zonder extra kosten! Goede prijs, prima app.",
        lang: "nl",
        source: "Android User",
        who: "Daniel & Rie",
    },
    {
        text: "Gewoon goed en veilig. Ook zonder abo.",
        lang: "nl",
        source: "Android User",
        who: "Paul Popeyus",
    },
    {
        text: "I recently started using Ente Photos, and I couldn't be happier with it! The ability to create albums and share them with family is a fantastic feature. They also have a client-side machine learning algorithm that makes it possible to search through your pictures based on words. And is cross-platform. The developer also has a nice personality. You can join the discord.",
        lang: "nl",
        source: "Android User",
        who: "Kenny",
    },
    {
        text: "Sono felicemente abbonato al piano di 200Gb e ho tutte le foto della mia vita in unico posto, semplice da usare e rispettoso dei miei dati e della mia privacy.",
        lang: "it",
        source: "Android User",
        who: "Mario Maccarone",
    },
    {
        text: "Funziona a meraviglia. Gli sviluppatori sono velocissimi nel sistemare i bug quando presenti e disponibili nel supporto. Le foto sono salvate in qualità massima e la sincronizzazione è veloce. Il costo è veramente basso (10€/anno o 1€/mese per 10gb), e a differenza di google photo (gratis, ovvero che fa soldi vendendo i nostri dati), è completamente open-source, utilizza la crittografia e2e (mentre google può tranquillamente vedere tutte le foto), e ha una privacy policy chiara e pulita.",
        lang: "it",
        source: "Android User",
        who: "Pi",
    },
    {
        text: "Intuitiva, facile da usare, libera",
        lang: "it",
        source: "Android User",
        who: "elisabeth zuddas",
    },
    {
        text: "Excelente app.",
        lang: "it",
        source: "Android User",
        who: "Simon",
    },
    {
        text: "En güvenli fotoğraflar uygulaması. Açık kaynak, özgür yazılım, harika arayüz. Daha ne olsun?",
        lang: "tr",
        source: "Apple User",
        who: "Flykeescape",
    },
    {
        text: "açık kaynak kodlu- 10 gb ücretsiz ve uçtan uca şifreleme ile çok iyi bir sistem ve ayrıca verilerimizin 3 tane farklı yerde korunması ile kaybetme riski ortadan kalkıyor",
        lang: "tr",
        source: "Android User",
        who: "Swexy",
    },
    {
        text: "Google Fotoğrafların en iyi alternatifi. Google'a günahımı vermem diyenler için ideal.",
        lang: "tr",
        source: "Android User",
        who: "Arda",
    },
    {
        text: "Uçtan uca şifreleme ve açık kaynak fotoğraf yedekleme uygulaması fazlasıyla iyi",
        lang: "tr",
        source: "Apple User",
        who: "Açık kaynak",
    },
    {
        text: "Açık kaynak kodlu - 10 GB ücretsiz - Fotoğrafları üç ayrı veri merkezinde saklıyor, biri Fransa'da eski bir nükleer sığınakta - Uçtan uca şifreleme, audit yapılmış - Kullanışlı arayüz ve gizlilik odaklı yapay zeka özellikleri E daha ne olsun 👌",
        lang: "tr",
        source: "Android User",
        who: "Samet TIRPAN",
    },
    {
        text: "Harika bir uygulama hem verileri uçtan uca şifreli hem kategoriler çok iyi teşekkürler Yusuf İpek.",
        lang: "tr",
        source: "Android User",
        who: "KARAHAN KORKMAZ",
    },
    {
        text: "Mahremiyetini önemseyenler için güzel uygulama",
        lang: "tr",
        source: "Android User",
        who: "Batu",
    },
    {
        text: "bunun gibi açık kaynak ve gizliliğe önem veren fotoğraflar uygulaması bulmak zor. herkese tavsiye ederim",
        lang: "tr",
        source: "Android User",
        who: "Samet Ağar",
    },
];

export default reviews;
